import styled from 'styled-components'

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 22px;
  padding: 0 6px;
  background: #2b2b2b;
  color: #e8e8e8;
  font-size: 11px;
  line-height: 22px;
  flex: 0 0 auto;
  user-select: none;
`

export const ChannelName = styled.span`
  font-weight: 600;
`

export const Speed = styled.span`
  color: ${p => (p.stale ? '#ff7875' : '#bfbfbf')};
  font-variant-numeric: tabular-nums;
`

export const HeaderRight = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 4px;
`

/** native select เพราะ antd Select สูงเกินแถบ 22px */
export const InlineSelect = styled.select`
  height: 16px;
  max-width: 110px;
  padding: 0 2px;
  border: 1px solid #555;
  border-radius: 2px;
  background: #3a3a3a;
  color: #e8e8e8;
  font-size: 10px;
  line-height: 1;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #1890ff;
  }
`

export const IconBtn = styled.button`
  width: 18px;
  min-width: 18px;
  height: 16px;
  padding: 0;
  border: 1px solid #555;
  border-radius: 2px;
  background: #3a3a3a;
  color: ${p => (p.danger ? '#ff4d4f' : '#d9d9d9')};
  font-size: 10px;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: #4a4a4a;
  }
`

export const RecordDot = styled.span`
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 7px solid #d0021b;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
`

/** ชื่อกล้องมุมขวาบนของแต่ละกล้องในกรอบ */
export const CameraName = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 0 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 10px;
  line-height: 14px;
  pointer-events: none;
  z-index: 2;
`

export const Overlay = styled.div`
  position: absolute;
  left: 6px;
  bottom: 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  pointer-events: none;
  z-index: 2;
`

export const OverlayLine = styled.span`
  align-self: flex-start;
  padding: 0 4px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 10px;
  line-height: 14px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`

export const StatusBox = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
  text-align: center;
  color: #d9d9d9;
  background: rgba(0, 0, 0, 0.35);
  z-index: 3;

  /* กล่องไม่รับเมาส์ ปุ่มในกล่อง (StatusAction) เปิด pointer-events กลับเองแล้ว */
  pointer-events: none;
`

// pointer-events: none ให้กดทะลุถึงวิดีโอได้
export const StatusBadge = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.6);
  color: #d9d9d9;
  font-size: 11px;
  pointer-events: none;
  z-index: 3;
`

/** ไอคอนคำอธิบายในป้าย — รับเมาส์เฉพาะจุดนี้ให้ title ขึ้น ตัวป้ายยังกดทะลุ */
export const BadgeHint = styled.span`
  cursor: help;
  pointer-events: auto;
`

/** ปุ่มในป้ายต้องกดได้ ทั้งที่ตัวป้ายกดทะลุ */
export const BadgeAction = styled.button`
  margin-left: auto;
  padding: 0 8px;
  border: 1px solid #595959;
  border-radius: 2px;
  background: #262626;
  color: #d9d9d9;
  font-size: 10px;
  line-height: 16px;
  cursor: pointer;
  pointer-events: auto;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
`

export const StatusText = styled.div`
  font-size: 12px;
  color: ${p => p.tone};
`

export const StatusHint = styled.div`
  font-size: 10px;
  color: #8c8c8c;
`

export const StatusActions = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 2px;
`

export const StatusAction = styled.button`
  pointer-events: auto;
  padding: 2px 10px;
  border: 1px solid #595959;
  border-radius: 2px;
  background: #262626;
  color: #d9d9d9;
  font-size: 11px;
  cursor: pointer;

  &:hover {
    border-color: #1890ff;
    color: #1890ff;
  }
`
